import React, { useContext, useEffect, useState } from 'react';
import { clearUserCredentials, getUserId, setAccessToken } from '../../backend/credentials';
import User, { UserType } from '../../models/User';
import { sleep } from '../../utils';
import { Busy } from '../core/busy';
import { Button } from '../core/button';
import { CheckboxField } from '../core/checkbox/CheckboxField';
import FontAwesomeIcon from '../core/fa_icon';
import { fetchUsers, getAppPermission } from './service';
import styles from './team_gatekeeper.module.scss';
import punycode from "punycode";
import { SalesContext } from '../../SalesContext';

/**
 * Checks the user's team to determine permission to use the app.
 */
export const TeamGatekeeper: React.FC = ({ children }) => {
  const [user, setUser] = useState<User>();
  const [isLogoutOnLeave, setLogoutOnLeave] = useState(true);

  const { setUserToken } = useContext(SalesContext);

  async function fetchUser() {
    for (let i = 0, retries = 2; i < retries; i++) {
      try {
        var users = await fetchUsers();
        
        setUser(users.find(user => user.id === getUserId()));
      } catch (e) {
        console.error(e);
        await sleep(1000);
      }
    }
  }

  useEffect(() => {
    fetchUser();
  }, []);

  if (!user) {
    return (
      <Busy className={styles.busy} />
    )
  }

  function logout() {
    clearUserCredentials();
    setAccessToken(null);
  }

  const targetApp = getAppPermission(user);

  if (!targetApp.isCurrentAppUsable) {
    return (
      <div className={styles.view}>
        <FontAwesomeIcon className={styles.icon} name="lock" />
        <h1 className={styles.title}>Du saknar behörighet till portalen</h1>
        {
          targetApp.app?.href ? (
            <>
              <a href={targetApp.app.href}>
                <Button weight="primary" onClick={() => {
                  if (isLogoutOnLeave) {
                    logout();
                  }
                }}>
                  Till {targetApp.app.name}
                </Button>
              </a>

              <CheckboxField
                label={`Logga ut mig från ${punycode.toUnicode(document.location.hostname)}`}
                checked={isLogoutOnLeave}
                onChange={setLogoutOnLeave} />
            </>
          ) : (
            <Button
              onClick={() => {
                logout();
                setUserToken(null);
              }}>
              Logga ut
            </Button>
          )
        }
      </div>
    );
  }

  return children as any;
}